import { render, staticRenderFns } from "./PanelPreviewAlert.vue?vue&type=template&id=4d6f317f&scoped=true"
import script from "./PanelPreviewAlert.vue?vue&type=script&lang=js"
export * from "./PanelPreviewAlert.vue?vue&type=script&lang=js"
import style0 from "./PanelPreviewAlert.vue?vue&type=style&index=0&id=4d6f317f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f317f",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSpinner,QBtn});
